import { ENV } from "../utils";

export class Setting {
  baseApi = ENV.BASE_API;

  async getSettings(token, category) {
    try {
      const url = category
        ? `${this.baseApi}/settings?category=${category}`
        : `${this.baseApi}/settings`;
      const params = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async upsertSettings(token, settings) {
    try {
      const url = `${this.baseApi}/settings/bulk`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ settings }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
